import React, { useEffect, useState } from "react"
import MicroModal from "micromodal"
import { StaticImage } from "gatsby-plugin-image"
import { useCookies } from "react-cookie"

const NavMain = () => {
    const [cookies] = useCookies([]);
    const [isLoggedIn, setIsLoggedIn] = useState(null)

  useEffect(() => {
    MicroModal.init({
      onShow: function (modal, element, event) {
        event.preventDefault()
        event.stopPropagation()
      },
      awaitCloseAnimation: true
    })
    setIsLoggedIn(!!cookies['member_id'])
  }, [])

  return (
    <div id="modal-1" aria-hidden="true" className="modal">    
      <div className="remodal-overlay" data-micromodal-close>
        <div id="barsmenu" className="remodal" div role="dialog" aria-modal="true" aria-labelledby="modal-1-title">
          <a href="/" className="remodal-close" data-micromodal-close><span>Close</span></a>
          <div className="bars_area">
            <a href="https://laxus.co/app/pc/home">
              <StaticImage className="logo-img" src="../images/logo-white.png" alt="Laxus" />
            </a>
            <div className="link_contents">
              <a href="https://app.adjust.com/6mkzmum" id="drawer-app-dl"><span>アプリで簡単レンタル</span><span className="komoji">まずは無料アプリをダウンロード！</span></a>
            </div>
            <div className="link_contents menu_icon bag">
              <a href="https://laxus.co/app/pc/bags">特集</a>
            </div>
            <div className="link_contents menu_icon bag">
              <a href="https://laxus.co/app/pc/blog/outfit">Outfit</a>
            </div>
            <div className="link_contents menu_icon bag">
              <a href="https://laxus.co/app/pc/blog/news">News</a>
            </div>
            <div className="link_contents menu_icon bag">
              <a href="https://laxus.co/app/pc/magazine">ブログ</a>
            </div>
            <div className="link_contents menu_icon bag"><span>おすすめ</span></div>
            <ul>
              <li className="brand"><a href="https://laxus.co/app/pc/bags/louis_vuitton">LOUIS VUITTON<span className="kana">（ルイ・ヴィトン）</span></a></li>
              <li className="brand"><a href="https://laxus.co/app/pc/bags/chanel">CHANEL<span className="kana">（シャネル）</span></a></li>
              <li className="brand"><a href="https://laxus.co/app/pc/bags/gucci">GUCCI<span className="kana">（グッチ）</span></a></li>
              <li className="brand"><a href="https://laxus.co/app/pc/bags/hermes">HERMES<span className="kana">（エルメス）</span></a></li>
              <li className="brand"><a href="https://laxus.co/app/pc/bags/celine">CELINE<span className="kana">（セリーヌ）</span></a></li>
              <li className="brand"><a href="https://laxus.co/app/pc/bags/prada">PRADA<span className="kana">（プラダ）</span></a></li>
              <li className="brand"><a href="https://laxus.co/app/pc/bags/fendi">FENDI<span className="kana">（フェンディ）</span></a></li>
              <li className="border brand-list"><a href="https://laxus.co/app/pc/info/brandlist">その他 取扱ブランド一覧</a></li>
              <li style={{color: "#fff", marginBottom: ".8em"}}>【特集】</li>
              <li><a href="https://laxus.co/app/pc/bags/newarrivals">New Arrivals</a></li>
              <li><a href="https://laxus.co/app/pc/bags/popular-items">今すぐ使える人気バッグ</a></li>
              <li><a href="https://laxus.co/app/pc/bags/shoulder-bags">ショルダーバッグ</a></li>
              <li><a href="https://laxus.co/app/pc/bags/mini-bags">おすすめミニバッグ特集</a></li>
              <li><a href="https://laxus.co/app/pc/bags/big-bags">日常に役立つビッグバッグ</a></li>
              <li style={{color: "#fff", marginBottom: ".8em"}}>【バッグの種類】</li>
              <li><a href="https://laxus.co/app/pc/bags/:クラッチバッグ">クラッチバッグ</a></li>
              <li><a href="https://laxus.co/app/pc/bags/:ショルダーバッグ">ショルダーバッグ</a></li>
              <li><a href="https://laxus.co/app/pc/bags/:トートバッグ">トートバッグ</a></li>
              <li><a href="https://laxus.co/app/pc/bags/:ハンドバッグ">ハンドバッグ</a></li>
              <li><a href="https://laxus.co/app/pc/bags/:2wayバッグ">2wayバッグ</a></li>
              <li className="border"><a href="https://laxus.co/app/pc/bags/:リュックサック">バックパック</a></li>
              <li><a href="https://laxus.co/app/pc/brands">ブランドヒストリー</a></li>                             
            </ul>
            <div className="menu_icon help"><span>ヘルプ</span></div>
            <ul>
              <li className="menu_icon faq"><a href="https://laxus.co/app/pc/info/howto">はじめてのご利用ガイド</a></li>
              <li className="menu_icon faq"><a href="https://laxus.co/app/pc/info/faq">よくある質問</a></li>
              <li className="menu_icon talk"><a href="https://laxus.co/app/pc/talk">トーク</a></li>
              <li className="menu_icon contact"><a href="https://laxus.co/app/pc/contact">お問い合わせ</a></li>
            </ul>
            {(isLoggedIn === null || isLoggedIn) && (
              <div className="link_contents menu_icon mypage">
                <a href='https://laxus.co/app/pc/mypage'>マイページ</a>
              </div>
            )}
            {(isLoggedIn === null || !isLoggedIn) && (
              <div className="link_contents menu_icon login">
                <a href='https://laxus.co/app/pc/login'>ログイン</a>
              </div>
            )}
            {(isLoggedIn === null || !isLoggedIn) && (
              <div className="link_contents menu_icon register">
                <a href='https://laxus.co/app/pc/login/register'>会員登録</a>
              </div>
            )}                                          
          </div>
        </div>
      </div>
    </div>
  )
}


export default NavMain
